module.exports = __webpack_public_path__ + "ai-features-3c5dae0f34fc6323c90f73ef8202c7ef.webp";